import type { BadgeProps } from "@bowfast/ui/components/badge";
import { ExpeditionStatus, VesselSource, VesselStatus, VesselType } from "../../graphql/generated";
import type { TabFilter } from "./vessels.types";

export const TYPE_LABEL: Record<VesselType, string> = {
  [VesselType.Monohull]: "Monohull",
  [VesselType.Catamaran]: "Catamaran",
  [VesselType.Trimaran]: "Trimaran",
  [VesselType.MotorSailer]: "Motor Sailer",
  [VesselType.TallShip]: "Tall Ship",
  [VesselType.Keelboat]: "Keelboat",
  [VesselType.Dinghy]: "Dinghy",
  [VesselType.Rib]: "RIB",
  [VesselType.Other]: "Other",
};

export const STATUS_CONFIG: Record<
  VesselStatus,
  { label: string; variant: BadgeProps["variant"]; dot?: boolean; pulse?: boolean }
> = {
  [VesselStatus.Active]: { label: "Active", variant: "active", dot: true },
  [VesselStatus.UnderMaintenance]: { label: "Under maintenance", variant: "pending", dot: true },
  [VesselStatus.Retired]: { label: "Retired", variant: "secondary" },
};

export const SOURCE_CONFIG: Record<VesselSource, { label: string; variant: BadgeProps["variant"] }> = {
  [VesselSource.Owned]: { label: "Owned", variant: "confirmed" },
  [VesselSource.ExternalCharter]: { label: "Chartered", variant: "charter" },
};

export const TAB_LABELS: Record<TabFilter, string> = {
  all: "All vessels",
  active: "Active",
  "under-maintenance": "Maintenance",
  retired: "Retired",
};

export const EXP_STATUS_CONFIG: Record<
  ExpeditionStatus,
  { label: string; variant: BadgeProps["variant"]; dot?: boolean; pulse?: boolean }
> = {
  [ExpeditionStatus.Active]: { label: "Active", variant: "active", dot: true, pulse: true },
  [ExpeditionStatus.Completed]: { label: "Completed", variant: "completed" },
  [ExpeditionStatus.Planning]: { label: "Planning", variant: "planning" },
  [ExpeditionStatus.Open]: { label: "Open", variant: "open" },
  [ExpeditionStatus.FullyBooked]: { label: "Fully booked", variant: "secondary" },
  [ExpeditionStatus.Cancelled]: { label: "Cancelled", variant: "secondary" },
};
